import { firestore } from 'firebase/app'
import { FirestoreQuery } from '../Firestore/FirestoreQuery'
import { Par } from './Par'
import { ParMapper } from './ParMapper'
import { CompanyTypeEnum } from '..'

export class ParCollection {
  protected collection: string = 'par'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  watchParsByCompanyId(companyId: string, companyType: CompanyTypeEnum): Par[] {
    const query = this.initQuery()
    query.setQuery(this.getParsByCompanyIdQuery(query, companyId, companyType))
    return query.watchList()
  }

  watchParsByRestaurantAndVendor(
    companyId: string,
    vendorId: string,
    cb?: (pars: Par[], unsub?: () => void) => void
  ): Par[] {
    const query = this.initQuery()
    query.setQuery(this.getActiveParsByRestaurantAndVendorQuery(query, companyId, vendorId))
    return query.watchList(cb)
  }

  list(): Promise<Par[]> {
    const query = this.initQuery()
    return query.list()
  }

  listParsByCompanyId(companyId: string, companyType: CompanyTypeEnum): Promise<Par[]> {
    const query = this.initQuery()
    query.setQuery(this.getParsByCompanyIdQuery(query, companyId, companyType))
    return query.list()
  }

  watch(id: string): { data: Par | null, unsub: () => void } {
    const query = this.initQuery()
    return query.watch(id)
  }

  async findParByRestaurantAndVendor(companyId: string, vendorId: string): Promise<Par | null> {
    const query = this.initQuery()
    query.setQuery(
      query.collection(this.collection)
        .where('restaurantCompanyId', '==', companyId)
        .where('vendorCompanyId', '==', vendorId)
        .limit(1)
    )

    return ( await query.list() )[0]
  }

  async findParByPriceListEntryId(priceListEntryId: string): Promise<Par | null> {
    const query = this.initQuery()
    query.setQuery(
      query.collection(this.collection)
        .where('priceListEntryId', '==', priceListEntryId)
        .limit(1)
    )

    return ( await query.list() )[0]
  }

  get(id: string): Promise<Par | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  save(par: Par): Promise<Par> {
    const query = this.initQuery()
    return query.save(par)
  }

  async delete(par: Par) {
    const query = this.initQuery();
    return query.delete(par)
  }

  protected initQuery(): FirestoreQuery<Par> {
    const query = new FirestoreQuery<Par>(this.db, new ParMapper())
    query.collection(this.collection)

    return query
  }

  protected getParsByCompanyIdQuery(query: FirestoreQuery<Par>, companyId: string, companyType: CompanyTypeEnum) {
    const field = companyType === CompanyTypeEnum.VENDOR ? 'vendorCompanyId' : 'restaurantCompanyId'
    return query.collection(this.collection).where(field, '==', companyId)
  }

  protected getActiveParsByRestaurantAndVendorQuery(query: FirestoreQuery<Par>, companyId: string, vendorId: string) {
    return query.collection(this.collection)
      .where('restaurantCompanyId', '==', companyId)
      .where('vendorCompanyId', '==', vendorId)
  }
}
